const state = {

    Review: [],

}

const mutations = {
    SetReview(state, payload) {

        state.Review = payload

    },
    SetIndividualReview(state, payload) {

        state.Review.push(...payload)

    },
    UpdateIndividualReview(state, payload) {

        let index = state['Review'].findIndex(x => x["_id"] == payload["_id"])
        state['Review'].splice(index, 1, payload)

    },
    DeleteIndividualReview(state, payload) {

        let index = state['Review'].findIndex(x => x["_id"] == payload["_id"])
        state['Review'].splice(index, 1)
    },
    DeleteMultipleReview(state, payload) {

        payload.forEach(element => {
            let index = state['Review'].findIndex(x => x["_id"] == element)
            state['Review'].splice(index, 1)
        });
    }
}

const actions = {

}

const getters = {

    GetReview(state) {

        return state.Review
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}